import React from 'react';
import useSWR from 'swr';
import { useDispatch } from 'react-redux';
import {
  fetchAvailableRedemptionsSWR,
  getAvailableRedemptionsUrl,
  handleRedemption,
} from './actions';
import RewardItem from './RewardItem';
import './rewards-list.css';

const RewardsList = ({
  userId,
  storeId,
  restaurantId,
  level,
  themeColors,
  userPoints,
  pointsTerminology = 'points',
}) => {
  const dispatch = useDispatch();

  // Get the URL for SWR to fetch available redemptions
  const redemptionsKey = getAvailableRedemptionsUrl(
    userId,
    storeId,
    restaurantId,
    level || 0
  );

  // Use SWR to fetch available redemptions
  const {
    data: availableRedemptions,
    error: availableRedemptionsError,
    isLoading: isLoadingAvailableRedemptions,
  } = useSWR(redemptionsKey, fetchAvailableRedemptionsSWR, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    dedupingInterval: 10000, // dedupe requests within 10 seconds
  });

  // Handle redemption with parameters as a single object
  const handleRedeemReward = async (redemptionId) => {
    try {
      const result = await handleRedemption({
        redemptionId,
        userId,
        storeId,
        restaurantId,
        level: level || 0,
        dispatch, // Pass the dispatch function to handleRedemption
      });

      // Success handling is now done in the handleRedemption function
    } catch (error) {
      console.error('Error redeeming reward:', error);
      // Could display an error message to the user here
    }
  };

  // Display loading state
  if (isLoadingAvailableRedemptions) {
    return (
      <div className='rewards-list-loading'>
        <div className='reward-placeholder'></div>
      </div>
    );
  }

  // Display error state
  if (availableRedemptionsError) {
    return (
      <div className='rewards-list-error'>
        Unable to load rewards. Please try again later.
      </div>
    );
  }

  // Display empty state if no redemptions available
  if (!availableRedemptions || availableRedemptions.length === 0) {
    return (
      <div className='rewards-list-empty'>
        <p>No rewards available at this time.</p>
      </div>
    );
  }

  return (
    <div className='rewards-list'>
      {availableRedemptions.map((redemption) => (
        <RewardItem
          key={redemption.id}
          title={redemption.name}
          description={redemption.description}
          points={redemption.points}
          imageUrl={redemption.imageUrl}
          canRedeem={userPoints >= redemption.points}
          onRedeem={() => handleRedeemReward(redemption.id)}
          themeColors={themeColors}
          pointsTerminology={pointsTerminology}
        />
      ))}
    </div>
  );
};

export default RewardsList;
